<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex flex-col lg:flex-row gap-2 justify-between items-center mb-10">
        <h1 class="text-app-primary-10 m-0">Präferenzen</h1>
        <button class="btn primary-button" (click)="submit()">
            <span>Speichern</span>
        </button>
    </div>

    <div class="w-full flex flex-col gap-6 pb-20">
        <cdk-accordion class="flex flex-col gap-6">
            <!-- Öffnungszeiten -->
            <cdk-accordion-item #openingHours="cdkAccordionItem" [expanded]="true">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="openingHours.toggle()" [attr.aria-expanded]="openingHours.expanded">
                        <span>Öffnungszeiten</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="openingHours.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (openingHours.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm">
                                <div formArrayName="consultingHours" class="flex flex-col gap-6 mt-6">
                                    @for (hour of consultingHours.controls; track hour; let i = $index) {
                                        <div [formGroupName]="i" class="grid grid-cols-1 md:grid-cols-12 gap-4 items-end bg-app-background-20/30 p-4 rounded-lg border border-app-primary-10/5">
                                            <div class="md:col-span-4 flex flex-col gap-2">
                                                <label class="text-sm font-medium">Tag</label>
                                                <mat-select formControlName="day" class="custom-select">
                                                    <mat-option [value]="'Montag'">Montag</mat-option>
                                                    <mat-option [value]="'Dienstag'">Dienstag</mat-option>
                                                    <mat-option [value]="'Mittwoch'">Mittwoch</mat-option>
                                                    <mat-option [value]="'Donnerstag'">Donnerstag</mat-option>
                                                    <mat-option [value]="'Freitag'">Freitag</mat-option>
                                                    <mat-option [value]="'Samstag'">Samstag</mat-option>
                                                    <mat-option [value]="'Sonntag'">Sonntag</mat-option>
                                                </mat-select>
                                            </div>
                                            <div class="md:col-span-3 flex flex-col gap-2">
                                                <label class="text-sm font-medium">Von</label>
                                                <input matInput type="time" formControlName="from">
                                            </div>
                                            <div class="md:col-span-3 flex flex-col gap-2">
                                                <label class="text-sm font-medium">Bis</label>
                                                <input matInput type="time" formControlName="to" (change)="checkTimeRange(hour)">
                                            </div>
                                            <div class="md:col-span-2 flex justify-end">
                                                <button class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                                        (click)="removeConsultingHour(i)">
                                                    <i class="fa-solid fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    <div class="flex justify-end mt-4">
                                        <button class="btn primary-button" (click)="triggerNewConsultingHour()">
                                            Öffnungszeiten hinzufügen
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Urlaubsplanung -->
            <cdk-accordion-item #vacationPlanning="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="vacationPlanning.toggle()" [attr.aria-expanded]="vacationPlanning.expanded">
                        <span>Urlaubsplanung</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="vacationPlanning.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (vacationPlanning.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm">
                                <div formArrayName="holidays" class="flex flex-col gap-6 mt-6">
                                    @for (holiday of holidays.controls; track holiday; let i = $index) {
                                        <div class="flex flex-col md:flex-row gap-4 items-end bg-app-background-20/30 p-4 rounded-lg border border-app-primary-10/5">
                                            <div class="flex-1 flex flex-col gap-2 w-full">
                                                <label class="text-sm font-medium">Urlaubszeit</label>
                                                <div class="datepicker-range">
                                                    <mat-date-range-input [rangePicker]="picker" [formGroupName]="i">
                                                        <input matStartDate formControlName="from" placeholder="Beginn">
                                                        <input matEndDate formControlName="to" placeholder="Ende">
                                                    </mat-date-range-input>
                                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-date-range-picker [touchUi]="isMobile" #picker="matDateRangePicker"></mat-date-range-picker>
                                                </div>
                                            </div>
                                            <button class="bg-red-500/10 hover:bg-red-500 text-red-500 hover:text-white w-14 h-14 flex items-center justify-center rounded-button transition-all"
                                                    (click)="removeHoliday(i)">
                                                <i class="fa-solid fa-times"></i>
                                            </button>
                                        </div>
                                    }
                                    <div class="flex justify-end mt-4">
                                        <button class="btn primary-button" (click)="triggerNewHoliday()">
                                            Urlaub hinzufügen
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Termineinstellungen -->
            <cdk-accordion-item #timeSlot="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="timeSlot.toggle()" [attr.aria-expanded]="timeSlot.expanded">
                        <span>Termineinstellungen</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="timeSlot.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (timeSlot.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                                <div class="flex flex-col gap-2">
                                    <label class="text-sm font-medium">Terminlänge (Minuten)</label>
                                    <input matInput type="number" formControlName="consultantDurationInMinutes" min="1" step="1">
                                </div>
                                <div class="flex flex-col gap-2">
                                    <label class="text-sm font-medium">Buchungsvorlauf (Wochen)</label>
                                    <input matInput type="number" formControlName="appointmentMaxToInWeeks">
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Kosten -->
            <cdk-accordion-item #costs="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="costs.toggle()" [attr.aria-expanded]="costs.expanded">
                        <span>Kosten</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="costs.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (costs.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm" class="flex flex-col gap-8 mt-6">
                                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    <div class="flex flex-col gap-2">
                                        <label class="text-sm font-medium">Behandlungskosten in €</label>
                                        <input matInput type="number" formControlName="treatmentCosts">
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label class="text-sm font-medium">Rezeptkosten in €</label>
                                        <input matInput type="number" formControlName="prescriptionCosts">
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label class="text-sm font-medium">Versandkosten in €</label>
                                        <input matInput type="number" formControlName="shippingCostsForPrescription">
                                    </div>
                                </div>

                                <div class="bg-app-background-20/50 p-6 rounded-lg border border-app-primary-10/10">
                                    <h4 class="text-app-primary-10 font-bold mb-4">Aliacura-Gebühren</h4>
                                    <p class="text-app-primary-20/70 text-sm mb-6 italic">Aliacura-Gebühren werden vom Administrator eingestellt.</p>
                                    <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                        <div class="flex flex-col gap-2">
                                            <label class="text-sm font-medium">Nutzungsgebühr in €</label>
                                            <input matInput type="number" formControlName="aliacuraPortalFees" readonly class="bg-gray-100 cursor-not-allowed">
                                        </div>
                                        <div class="flex flex-col gap-2">
                                            <label class="text-sm font-medium">Versandgebühr in €</label>
                                            <input matInput type="number" formControlName="aliacuraPostage" readonly class="bg-gray-100 cursor-not-allowed">
                                        </div>
                                        <div class="flex flex-col gap-2">
                                            <label class="text-sm font-medium">Abholungsgebühr in €</label>
                                            <input matInput type="number" formControlName="aliacuraDebtCollectionFees" readonly class="bg-gray-100 cursor-not-allowed">
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Stempel und Unterschrift -->
            <cdk-accordion-item #stamp="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="stamp.toggle(); loadSignatureToPad()" [attr.aria-expanded]="stamp.expanded">
                        <span class="text-start">Stempel und Unterschrift</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="stamp.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (stamp.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm" class="flex flex-col gap-10 mt-6">
                                <div class="flex flex-col gap-4">
                                    <label class="text-app-primary-10 font-bold">Stempel</label>
                                    @if (doctorSettingsForm.get('stamp')?.value == '' || doctorSettingsForm.get('stamp')?.value == undefined) {
                                        <app-file-upload
                                            [maxFileSize]="200 * 1024"
                                            [allowedMimeTypes]="['image/png']"
                                            (fileSelected)="triggerFileUpload($event)"
                                            class="w-full">
                                        </app-file-upload>
                                    } @else {
                                        <div class="relative group bg-white p-4 rounded-lg border border-app-primary-10/10 shadow-sm flex flex-col items-center">
                                            <img class="max-h-48 object-contain mb-4" [src]="'data:image/jpeg;base64,' + doctorSettingsForm.get('stamp')?.value">
                                        </div>
                                    }
                                    <div class="flex gap-4 mt-2 justify-end">
                                        <button class="btn secondary-button" (click)="clearStamp()">
                                            Stempel löschen
                                        </button>
                                    </div>
                                </div>
                                <div class="flex flex-col gap-4">
                                    <label class="text-app-primary-10 font-bold">Unterschrift</label>
                                    <div class="bg-app-background-20 rounded-lg p-4 border border-app-primary-10/10 flex justify-center">
                                        <signature-pad #signature [options]="signaturePadOptions" (drawEnd)="drawComplete()"></signature-pad>
                                    </div>
                                    <div class="flex gap-4 mt-2 justify-end">
                                        <button class="btn secondary-button" (click)="clearSignature()">
                                            Unterschrift Löschen
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Passwort -->
            <cdk-accordion-item #password="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="password.toggle()" [attr.aria-expanded]="password.expanded">
                        <span>Passwort</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="password.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (password.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="passwordForm" class="flex flex-col gap-6 mt-6">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div class="flex flex-col gap-2">
                                        <label class="text-sm font-medium">Neues Passwort</label>
                                        <input matInput type="password" formControlName="newPassword">
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <label class="text-sm font-medium">Passwort wiederholen</label>
                                        <input matInput type="password" formControlName="passwordConfirm">
                                        @if (passwordForm.get('passwordConfirm')?.valid && passwordForm.get('newPassword')?.value !== passwordForm.get('passwordConfirm')?.value) {
                                            <mat-error class="text-xs text-red-500 mt-1">* Passwörter stimmen nicht überein</mat-error>
                                        }
                                    </div>
                                </div>
                                <div class="flex justify-end">
                                    <button class="btn primary-button" (click)="updatePassword()">Passwort aktualisieren</button>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>

            <!-- Standardtexte -->
            <cdk-accordion-item #customEmailText="cdkAccordionItem">
                <div class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10/5 overflow-hidden">
                    <button
                        class="flex justify-between items-center w-full p-6 text-app-primary-10 font-bold text-lg lg:text-xl hover:bg-gray-50 transition-colors"
                        (click)="customEmailText.toggle()" [attr.aria-expanded]="customEmailText.expanded">
                        <span>Standardtexte</span>
                        <i class="fa-solid text-xl transition-transform"
                           [ngClass]="customEmailText.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
                    </button>

                    @if (customEmailText.expanded) {
                        <div class="p-6 pt-0 border-t border-app-primary-10/5">
                            <form [formGroup]="doctorSettingsForm" class="flex flex-col gap-4 mt-6">
                                <div class="flex flex-col gap-2">
                                    <label class="text-sm font-medium">Standardtext für E-Mails</label>
                                    <textarea matInput formControlName="customTextForEmail" class="min-h-[150px]"></textarea>
                                </div>
                            </form>
                        </div>
                    }
                </div>
            </cdk-accordion-item>
        </cdk-accordion>
    </div>

    <div class="w-full flex justify-end mt-4 mb-20">
        <button class="btn primary-button" (click)="submit()">
            <span>Speichern</span>
        </button>
    </div>
</div>
